// ===========================================
// Email Domain Tab Component
// ===========================================
// Custom sending domain — coming soon placeholder

import {
  Alert,
  Box,
  Typography,
} from '@mui/material';
import {
  Construction as ConstructionIcon,
} from '@mui/icons-material';

// ===========================================
// MAIN COMPONENT
// ===========================================

export default function EmailDomainTab() {
  return (
    <Box>
      {/* Header */}
      <Typography variant="h6" gutterBottom>
        Custom Sending Domain
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Send emails from your own domain (e.g., info@yourmusicschool.com) instead of the default
        platform address.
      </Typography>

      {/* Coming Soon Notice */}
      <Alert
        severity="info"
        icon={<ConstructionIcon />}
        sx={{ mb: 3 }}
      >
        <Typography variant="body2">
          <strong>Coming Soon</strong> — Custom sending domains are currently being finalised.
          If you would like to set this up now, please contact system support and we will configure
          it for you.
        </Typography>
      </Alert>
    </Box>
  );
}
